/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

// fee types
export const RECREATION_FEE = 'RecreationFee';
export const RESERVATION_FEE = 'ReservationFee';
export const LOTTERY_APPLICATION_FEE = 'LotteryFee';
export const CLIN_FEE = 'CLIN';
export const TRANSACTION_FEE = 'TransactionFee';
export const USE_FEE = 'UseFee';
export const TICKET_FEE = 'TicketFee';
export const ATTRIBUTE_FEE = 'AttributeFee';
export const POS_FEE = 'POSFee';
export const TAX_FEE = 'TaxFee';
export const ATTRIBUTE_FEE_DESCRIPTION = 'FeeDescription';

// permission types
export const GET_PERMISSION = 'VP_GET_PERMISSION';
export const NOT_ALLOWED = 'notAllowed';

// order
export const GET_ORDER = 'VP_GET_ORDER';
export const GET_ORDER_ERROR = 'VP_GET_ORDER_ERROR';

// permit
export const GET_PERMIT = 'VP_GET_PERMIT';
export const GET_PERMIT_ERROR = 'VP_GET_PERMIT_ERROR';
export const SET_PERMIT_TYPE = 'VP_SET_PERMIT_TYPE';
export const SET_PERMIT_DATE = 'VP_SET_PERMIT_DATE';
export const SET_SELECTED_DIVISION = 'VP_SET_SELECTED_DIVISION';
export const SET_SELECTED_START_DATE = 'VP_SET_SELECTED_START_DATE';
export const SET_SELECTED_END_DATE = 'VP_SET_SELECTED_END_DATE';
export const SET_DISTRICTS = 'SET_DISTRICTS';
export const SET_VALIDATION_ERROR = 'VP_SET_VALIDATION_ERROR';
export const GET_RECAREA = 'VP_GET_RECAREA';
export const GET_RECAREA_ERROR = 'VP_GET_RECAREA_ERROR';
export const GET_PERMIT_RESERVATION_ALERT = 'VP_GET_PERMIT_RESERVATION_ALERT';
export const GET_PERMIT_RESERVATION_ALERT_ERROR = 'VP_GET_PERMIT_RESERVATION_ALERT_ERROR';
export const CLEAR_PERMIT = `VP_CLEAR_PERMIT`;
export const GET_PERMIT_ISSUANCES = 'VP_GET_PERMIT_ISSUANCES';
export const GET_PERMIT_ISSUANCES_ERROR = 'VP_GET_PERMIT_ISSUANCES_ERROR';
export const SET_ACTIVE_TAB = 'VP_SET_ACTIVE_TAB';
export const SET_DIV_SEARCH_CRITERIA = 'VP_SET_DIV_SEARCH_CRITERIA';

// seasons
export const GET_SEASONS = 'VP_GET_SEASONS';
export const GET_SEASONS_ERR = 'VP_GET_SEASONS_ERR';
export const YEAR_ADD_SUCCESS = 'VP_YEAR_ADD_SUCCESS';
export const YEAR_ADD_ERR = 'VP_YEAR_ADD_ERR';
export const SEASON_ADD_SUCCESS = 'VP_SEASON_ADD_SUCCESS';
export const SEASON_ADD_ERR = 'VP_SEASON_ADD_ERR';
export const SEASON_MOD_SUCCESS = 'VP_SEASON_MOD_SUCCESS';
export const SEASON_MOD_ERR = 'VP_SEASON_MOD_ERR';
export const CHANGE_SELECTED_YEAR = 'VP_CHANGE_SELECTED_YEAR';

// Availability
export const GET_DIVISION_INSTANCES = 'VP_GET_DIVISION_INSTANCES';
export const GET_DIVISION_INSTANCES_ERROR = 'VP_GET_DIVISION_INSTANCES_ERROR';
export const SET_DIVISIONS_MULTISIZED = 'VP_SET_DIVISIONS_MULTISIZED';
export const GET_DIVISION_INSTANCES_STARTED = 'VP_GET_DIVISION_INSTANCES_STARTED';
export const SET_AVAILABILITY_FILTER_DATE = 'VP_SET_AVAILABILITY_FILTER_DATE';

// issuance
export const POST_ISSUANCE_START = 'VP_POST_ISSUANCE_START';
export const POST_ISSUANCE = 'VP_POST_ISSUANCE';
export const CLEAR_ISSUANCE_LIST = 'VP_CLEAR_ISSUANCE_LIST';
export const POST_ISSUANCE_ERROR = 'VP_POST_ISSUANCE_ERROR';
export const POST_ISSUANCE_CALCULATE_FEES = 'VP_POST_ISSUANCE_CALCULATE_FEES';
export const POST_ISSUANCE_CALCULATE_FEES_ERROR = 'VP_POST_ISSUANCE_CALCULATE_FEES_ERROR';
export const POST_ISSUANCE_CARTLESS = 'VP_POST_ISSUANCE_CARTLESS';
export const POST_ISSUANCE_CARTLESS_ERROR = 'VP_POST_ISSUANCE_CARTLESS_ERROR';
export const UPDATE_ISSUANCE = 'VP_UPDATE_ISSUANCE';
export const UPDATE_ISSUANCE_ERROR = 'VP_UPDATE_ISSUANCE_ERROR';
export const GET_ISSUANCE = 'VP_GET_ISSUANCE';
export const GET_ISSUANCE_ERROR = 'VP_GET_ISSUANCE_ERROR';
export const GET_ALL_ISSUANCES = 'VP_GET_ALL_ISSUANCES';
export const GET_ALL_ISSUANCES_ERROR = 'VP_GET_ALL_ISSUANCES_ERROR';
export const GET_ISSUANCE_BY_STATUS = 'VP_GET_ISSUANCE_BY_STATUS';
export const GET_ISSUANCE_BY_STATUS_ERROR = 'VP_GET_ISSUANCE_BY_STATUS_ERROR';
export const GET_ISSUANCES_BY_PERMIT = 'VP_GET_ISSUANCES_BY_PERMIT';
export const GET_ISSUANCES_BY_PERMIT_ERROR = 'VP_GET_ISSUANCES_BY_PERMIT_ERROR';
export const GET_ISSUANCE_PDF = 'VP_GET_ISSUANCE_PDF';
export const GET_ISSUANCE_PDF_ERROR = 'VP_GET_ISSUANCE_PDF_ERROR';
export const CANCEL_ISSUANCE = 'VP_CANCEL_ISSUANCE';
export const CANCEL_ISSUANCE_ERROR = 'VP_CANCEL_ISSUANCE_ERROR';
export const GET_USER_ISSUANCES = 'VP_GET_USER_ISSUANCES';
export const GET_USER_ISSUANCES_ERROR = 'VP_GET_USER_ISSUANCES_ERROR';
export const ISSUANCE_UPDATE_REQUIRES_PAYMENT = 'UpdateRequiresPayment';
export const ISSUANCE_UPDATE_SUCCESSFUL = 'UpdateSuccessful'; // go to confirmation page / populate redux
export const ISSUANCE_UPDATE_VALIDATION_ERROR = 'ValidationError';
export const CLEAR_ISSUANCE_BY_STATUS = `VP_CLEAR_ISSUANCE_BY_STATUS`;
export const CLEAR_ISSUANCES_BY_PERMIT = `VP_CLEAR_ISSUANCES_BY_PERMIT`;
export const POST_ISSUANCES_STATUS = 'VP_POST_ISSUANCES_STATUS';
export const POST_ISSUANCES_STATUS_ERROR = 'VP_POST_ISSUANCES_STATUS_ERROR';
export const CLEAR_POST_ISSUANCES_STATUS = `VP_CLEAR_POST_ISSUANCES_STATUS`;
export const CLEAR_FILTERS = `VP_CLEAR_FILTERS`;
export const CLEAR_RESERVATION = `VP_CLEAR_RESERVATION`;
export const CLEAR_POST_ISSUANCE = `VP_CLEAR_POST_ISSUANCE`;
export const ISSUANCE_LIST_CREATED = 'ISSUANCE_LIST_CREATED';
export const ISSUANCE_LIST_CREATED_ERR = 'ISSUANCE_LIST_CREATED_ERR';
export const DISPLAY_UI_VALIDATIONS = 'DISPLAY_UI_VALIDATIONS';
export const CLEAR_DISPLAY_UI_VALIDATION = 'CLEAR_DISPLAY_UI_VALIDATION';
export const ISS_MANAGEMENT_SET_SELECTED_FILTER_OPTION =
    'ISS_MANAGEMENT_SET_SELECTED_FILTER_OPTION';
export const ISS_MANAGEMENT_SET_FILTER_DETAILS = 'ISS_MANAGEMENT_SET_FILTER_DETAILS';
export const ISS_MANAGEMENT_RESET_FILTER_DETAILS = 'ISS_MANAGEMENT_RESET_FILTER_DETAILS';
export const ISS_MANAGEMENT_SET_FILTER_PAGE = 'ISS_MANAGEMENT_SET_FILTER_PAGE';

// Inventory management
export const INV_MANAGEMENT_TOGGLE_FILTER = 'INV_MANAGEMENT_TOGGLE_FILTER';
export const INV_MANAGEMENT_SETIN_FILTER = 'INV_MANAGEMENT_SETIN_FILTER';
export const INV_MANAGEMENT_UNSET_FILTER = 'INV_MANAGEMENT_UNSET_FILTER';
export const INV_MANAGEMENT_CLEAR_RESULTS = 'INV_MANAGEMENT_CLEAR_RESULTS';
export const INV_MANAGEMENT_REFRESH_RESULT = 'INV_MANAGEMENT_REFRESH_RESULT';
export const INV_MANAGEMENT_REFRESH_RESULT_ERR = 'INV_MANAGEMENT_REFRESH_RESULT_ERR';
export const INV_MANAGEMENT_SET_SORT = 'INV_MANAGEMENT_SET_SORT';
export const INV_MANAGEMENT_GRID_LOADING = 'INV_MANAGEMENT_GRID_LOADING';
export const INV_MANAGEMENT_RESET_FILTER = 'INV_MANAGEMENT_RESET_FILTER';
export const INV_MANAGEMENT_SELECTION_CHANGE = 'INV_MANAGEMENT_SELECTION_CHANGE';
export const INV_MANAGEMENT_SELECTION_ALL_CHANGE = 'INV_MANAGEMENT_SELECTION_ALL_CHANGE';
export const INV_MANAGEMENT_RESERVABLE_STATUS_CHANGE =
    'INV_MANAGEMENT_RESERVABLE_STATUS_CHANGE';
export const INV_MANAGEMENT_RELEASE_METHOD_CHANGE =
    'INV_MANAGEMENT_RELEASE_METHOD_CHANGE';
export const INV_MANAGEMENT_RELEASE_TIMESTAMP_CHANGE =
    'INV_MANAGEMENT_RELEASE_TIMESTAMP_CHANGE';
export const INV_MANAGEMENT_UPDATE_RESULT = 'INV_MANAGEMENT_UPDATE_RESULT';
export const INV_MANAGEMENT_UPDATE_RESULT_ERR = 'INV_MANAGEMENT_UPDATE_RESULT_ERR';

// Advanced search constants
export const ADVANCED_FILTER_TYPE = 'ADVANCED_FILTER_TYPE';
export const CUSTOMER_FILTER_TYPE = 'CUSTOMER_FILTER_TYPE';
export const RESERVATION_FILTER_TYPE = 'RESERVATION_FILTER_TYPE';

// reservation types
export const FETCH_RESERVATION_START = `VP_FETCH_RESERVATION_START`;
export const FETCH_RESERVATION_SUCCESS = `VP_FETCH_RESERVATION_SUCCESS`;
export const FETCH_RESERVATION_FAILURE = `VP_FETCH_RESERVATION_FAILURE`;
export const CREATE_RESERVATION_START = `VP_CREATE_RESERVATION_START`;
export const CREATE_RESERVATION_SUCCESS = `VP_CREATE_RESERVATION_SUCCESS`;
export const CREATE_RESERVATION_FAILURE = `VP_CREATE_RESERVATION_FAILURE`;
export const UPDATE_RESERVATION_START = `VP_UPDATE_RESERVATION_START`;
export const UPDATE_RESERVATION_SUCCESS = `VP_UPDATE_RESERVATION_SUCCESS`;
export const UPDATE_RESERVATION_FAILURE = `VP_UPDATE_RESERVATION_FAILURE`;
export const UPDATE_CURRENT_RESERVATION = `VP_UPDATE_CURRENT_RESERVATION`;

// access info
export const ADD_NEW_PENDING_ACCESSINFO = 'VP_ADD_NEW_PENDING_ACCESSINFO';
export const CREATE_PENDING_ACCESSINFO = 'VP_CREATE_PENDING_ACCESSINFO';
export const SET_PENDING_ACCESSINFO_PROP = 'VP_SET_PENDING_ACCESSINFO_PROP';
export const SAVE_PENDING_ACCESSINFO = 'VP_SAVE_PENDING_ACCESSINFO';
export const SAVE_PENDING_ACCESSINFO_ERR = 'VP_SAVE_PENDING_ACCESSINFO_ERR';
export const DISMISS_DISPLAY_SUCCESS_MEESAGE = 'VP_DISMISS_DISPLAY_SUCCESS_MEESAGE';
export const DISMISS_DISPLAY_ERROR_MEESAGE = 'VP_DISMISS_DISPLAY_ERROR_MEESAGE';
export const DISPLAY_SUCCESS_MEESAGE = 'VP_DISPLAY_SUCCESS_MEESAGE';

export const START_LOADING_BUTTON = 'VP_START_LOADING_BUTTON';
export const DONE_LOADING_BUTTON = 'VP_DONE_LOADING_BUTTON';

// account
export const GET_ACCOUNT_NAME = 'GET_ACCOUNT_NAME';
export const GET_ACCOUNT_NAME_ERROR = 'GET_ACCOUNT_NAME_ERROR';

// reservation detail
export const PERMIT = 'PERMIT';

export const EPOCH_MULTIPLIER = 1000;
export const SEND_CURRENT_DATE = 'SEND_CURRENT_DATE';

// fee display models
export const ONE_FEE = 'OneFee';
export const ADD_ON_FEE = 'AddOnFee';

// Data certification
export const GET_CERTIFICATIONS = 'VP_GET_CERTIFICATIONS';
export const GET_CERTIFICATIONS_ERROR = 'VP_GET_CERTIFICATIONS_ERROR';
export const POST_CERTIFICATION = 'VP_POST_CERTIFICATION';
export const POST_CERTIFICATION_ERROR = 'VP_POST_CERTIFICATION_ERROR';

export const SKU_VEHICLE_USE_FEE = 'PERUSE250848ADULT';
export const SKU_IAP_USE_FEE = 'PERUSE250848IAP';
export const SKU_ISP_USE_FEE = 'PERUSE250848ISP';
export const SKU_IYAP_USE_FEE = 'PERUSE250848IYAP';
export const SKU_SPH_USE_FEE = 'PERUSE250848SPH';
export const SKU_TCH_USE_FEE = 'PERUSE250848TCH';
export const SKU_MIN_BALANCE_FEE = 'PERMIN250848';
export const SKU_TX_FEE = 'PERRES250848';

export const ADULT_FEE_TYPE = '1';
export const CHILD_FEE_TYPE = '2';
export const INTER_SENIOR_FEE_TYPE = '3';
export const INTER_ACCESS_FEE_TYPE = '4';
export const INTER_YOUTH_ACCESS_FEE_TYPE = '5';
export const SEASON_CARD_FEE_TYPE = '6';
export const TREATY_CARD_FEE_TYPE = '7';

export const RES_ID_DELIMITER = '__';

// cart
export const GET_CART = 'GET_CART';
export const GET_CART_ERROR = 'GET_CART_ERROR';
export const CANCEL_RESERVATION = 'CANCEL_RESERVATION';
export const CANCEL_RESERVATION_ERROR = 'CANCEL_RESERVATION_ERROR';

// issuance statuses
export const PERMIT_PRELIMINARY = 'Preliminary';
export const PERMIT_IN_PROGRESS = 'In Progress';
export const PERMIT_COMPLETE = 'Reserved';
export const PERMIT_ISSUED = 'Issued';
export const CANCELLED_NO_RELEASE = 'Cancelled';
export const PERMIT_CANCELLED_BY_USER = 'Cancelled';
export const PERMIT_VOIDED = 'Refunded';
export const PERMIT_NO_SHOW = 'No Show';
export const LOTTERY_CANCELLED = 'LotteryCancelled';
export const LOTTERY_AWARDED = 'LotteryAwarded';
export const LOTTERY_WON = 'LotteryWon';
export const LOTTERY_WON_IN_PROGRESS = 'LotteryWonInProgress';

// issuance readable statuses
export const PERMIT_PRELIMINARY_READABLE = 'Preliminary';
export const PERMIT_IN_PROGRESS_READABLE = 'In Progress';
export const PERMIT_COMPLETE_READABLE = 'Reserved';
export const PERMIT_ISSUED_READABLE = 'Issued';
export const PERMIT_NO_SHOW_READABLE = 'No Show';
export const PERMIT_CANCELLED_READABLE = 'Cancelled';
export const PERMIT_VOIDED_READABLE = 'Refunded';

export const PERMIT_ISSUANCE_STATUSES = {
    [PERMIT_IN_PROGRESS]: PERMIT_IN_PROGRESS_READABLE,
    [PERMIT_COMPLETE]: PERMIT_COMPLETE_READABLE,
    [PERMIT_ISSUED]: PERMIT_ISSUED_READABLE,
    [PERMIT_CANCELLED_BY_USER]: PERMIT_CANCELLED_READABLE,
    [PERMIT_VOIDED]: PERMIT_VOIDED_READABLE,
    [PERMIT_NO_SHOW]: PERMIT_NO_SHOW_READABLE,
};

// issuance types
export const PRIVATE = 'Private';
export const COMMERCIAL = 'Commercial';
export const ADMIN = 'Admin';

// external validations
export const IS_ISSUE_STATION_EMPTY = 'IsIssueStationEmpty';
export const IS_ENTRY_DATE_EMPTY = 'IsEntryDateEmpty';
export const IS_EXIT_DATE_EMPTY = 'IsExitDateEmpty';
export const IS_GROUP_MEMBER_EMPTY = 'IsGroupMemberEmpty';
export const IS_EQUIPMENT_EMPTY = 'IsEquipmentEmpty';
export const IS_NEED_TO_KNOW_CHECKED = 'IsNeedToKnowChecked';

// validation targets
export const ENTRY_POINT = 'entryPoint';
export const EXIT_POINT = 'exitPoint';
export const ISSUE_STATION = 'issueStation';
export const GROUP_MEMBERS = 'groupMembers';
export const EXIT_DATE = 'exitDate';
export const SEASON_START_DATE = 'lotterySeasonStartDate';
export const SEASON_END_DATE = 'lotterySeasonEndDate';
export const NEED_TO_KNOW_CHECKBOX = 'needToKnowChecked';
export const DIVISION_ID = 'divisionId';
export const SELECTED_DATES = 'selectedDates';
export const LOTTERY_INFO_DISPLAY_DATE = 'lotteryInfoDisplayDate';
export const LOTTERY_NOTIFY_DATE = 'lotteryNotifyDate';
export const LOTTERY_OPEN_DATE = 'lotteryOpenDate';
export const LOTTERY_RUN_DATE = 'lotteryRunDate';
export const WATERCRAFTS = 'watercrafts';

// validation types
export const REQUIRED_BOOLEAN_FIELD = 'REQUIRED_BOOLEAN_FIELD';
export const REQUIRED_STRING_FIELD = 'REQUIRED_STRING_FIELD';
export const REQUIRED_DATE_FIELD = 'REQUIRED_DATE_FIELD';
export const REQUIRED_LIST_FIELD = 'REQUIRED_LIST_FIELD';
export const REQUIRED_NUM_FIELD = 'REQUIRED_NUM_FIELD';
export const REQUIRED_LIST_ENTRY_FIELD = 'REQUIRED_LIST_ENTRY_FIELD';
export const PERMIT_REGISTRATION = 'PermitRegistration';
export const LOTTERY_REGISTRATION = 'LotteryRegistration';
export const REGISTRATION = 'Registration';

// detailed availability
export const AVAILABILITY_DAYS_TO_DISPLAY = 10;
export const AVAILABILITY_DAYS_TO_SKIP = 5;
export const AVAILABILITY_UNSELECTED = 'AVAILABILITY_UNSELECTED';
export const AVAILABILITY_START_MULTIDAY = 'AVAILABILITY_START_MULTIDAY';
export const AVAILABILITY_CONTINUE_MULTIDAY = 'AVAILABILITY_CONTINUE_MULTIDAY';
export const AVAILABILITY_END_MULTIDAY = 'AVAILABILITY_END_MULTIDAY';
export const AVAILABILITY_SINGLE_DAY = 'AVAILABILITY_SINGLE_DAY';

export const GROUP_AVAILABILITY_DAILY_KEY_NAME = 'ConstantQuotaUsageDaily';
export const GROUP_AVAILABILITY_KEY_NAME = 'ConstantQuotaUsageByStartDate';
export const MEMBER_AVAILABILITY_KEY_NAME = 'QuotaUsageByMember';
export const AGGREGATE_AVAILABILITY_KEY_NAME = 'AggregateQuota';
export const WATERCRAFT_AVAILABILITY_KEY_NAME = 'QuotaUsageByWatercraft';
export const MAX_STOCK_KEY_NAME = 'MaxStock';
export const FILTER_NUMERICAL = 'numerical';

// common date format strings
export const DATE_FORMAT = 'ddd, MMM D, YYYY';
export const DATE_TIME_FORMAT = 'ddd, MMM D, YYYY | hh:mmA z';
export const MONTH_DAY_YEAR_FORMAT = 'MMM Do YYYY';
export const AVAILABILITY_KEY_MAP_FORMAT = 'MM/DD/YYYY';
export const MONTH_DAY_YEAR_NUM_FORMAT = 'MM/DD/YYYY';

// sales channel types
export const ONLINE = 'ONLINE';
export const FIELD_SALES = 'FIELD_SALES';
export const CALL_CENTER = 'CALL_CENTER';

// division status enum
export const DIVISION_STATUS = {
    CLOSED: 0,
    OPEN: 1,
};

export const FINALIZE_CHECKOUT = 'FINALIZE_CHECKOUT';
export const CLEAR_ISSUANCE = 'CLEAR_ISSUANCE';

// permit types enum
export const PERMIT_TYPE_RIVER = 'PERMIT_TYPE_RIVER';
export const PERMIT_TYPE_HIKING = 'PERMIT_TYPE_HIKING';
export const PERMIT_TYPE_CAMPING = 'PERMIT_TYPE_CAMPING';
export const PERMIT_TYPE_CLIMBING = 'PERMIT_TYPE_CLIMBING';
export const PERMIT_TYPE_WILDLIFE = 'PERMIT_TYPE_WILDLIFE';
export const PERMIT_TYPE_ROADENTRY = 'PERMIT_TYPE_ROADENTRY';
export const PERMIT_TYPE_EVENT = 'PERMIT_TYPE_EVENT';
export const PERMIT_TYPE_BOAT = 'PERMIT_TYPE_BOAT';
export const PERMIT_TYPE_SNOWMOBILE = 'PERMIT_TYPE_SNOWMOBILE';
export const PERMIT_TYPE_WILDERNESS = 'PERMIT_TYPE_WILDERNESS';

// lottery preferences rules constants
export const LOTTERY_PREFERENCES_TYPE = 'LotteryPreferencesType';
export const LOTTERY_PREFERENCE_SELECTION_LIMIT = 'LotteryPreferenceSelectionLimit';

// lottery preferences enum
export const LOTTERY_PREFERENCE_TYPES = {
    DATE: 1,
    DATE_DIVISION: 2,
    DATE_DIVISION_DURATION: 3,
    DATE_DIVISION_GROUP_MIN_MAX: 4,
    DATE_DIVISION_GROUP_MAX: 5,
};

export const PERMIT_START_DATE_FILTER_TYPE = 'PERMIT_START_DATE_FILTER_TYPE';
export const ORDERED_DATE_FILTER_TYPE = 'ORDERED_DATE_FILTER_TYPE';

// Error Messages
export const ERROR_UNAUTHORIZED = 'You are not authorized to access this page.';
export const ERROR_DEFAULT = 'Something went wrong, please try again later.';

// fee calculation models
export const NO_USE_FEE = 0;
export const FLAT_USE_FEE = 1;
export const PER_MEMBER_FEE = 3;

// alternate permit holder
export const VERIFY_ALTERNATE = 'VERIFY_ALTERNATE';
export const VERIFY_ALTERNATE_ERROR = 'VERIFY_ALTERNATE_ERROR';

export const CONFIRM_ALTERNATE = 'CONFIRM_ALTERNATE';
export const CONFIRM_ALTERNATE_ERROR = 'CONFIRM_ALTERNATE_ERROR';
export const CUSTOMER_SELECTED = 'CUSTOMER_SELECTED';
export const CUSTOMER_CLEARED = 'CUSTOMER_CLEARED';

// Loading Buttons
export const LOADING_IDS = {
    PRINT_PERMIT_PDF: 'PRINT_PERMIT_PDF',
};

export const progressSteps = ['Order Details', 'Review Cart', 'Payment', 'Confirmation'];

export const FLEX_FIELD_1 = 'FLEX_FIELD_1';
export const FLEX_FIELD_2 = 'FLEX_FIELD_2';
